import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ProfileModel } from '../models/profile.model';
import { IProfileService, PROFILE_SERVICE } from '../services/IProfile.service';
import * as ProfileActions from './profile.actions';

@Injectable()
export class ProfileEffects {
  loadProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProfileActions.ProfileActionTypes.loadProfileBegin),
      switchMap(() =>
        this.service.getProfile().pipe(
          map((profile) =>
            ProfileActions.loadProfileSuccessAction({ payload: profile })
          ),
          catchError((error) => {
            console.error('Could not load Profile');
            return of(ProfileActions.loadProfileFailAction({ errors: error }));
          })
        )
      )
    )
  );

  updateProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProfileActions.ProfileActionTypes.updateProfileBegin),
      switchMap((action) =>
        this.service.updateProfile((action as any).profileForm).pipe(
          map((response) =>
            ProfileActions.updateProfileSuccessAction({ response })
          ),
          catchError((error) => {
            console.error('Could not UPDATE Profile', error);
            return of(
              ProfileActions.updateProfileFailAction({ errors: error })
            );
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    @Inject(PROFILE_SERVICE) private service: IProfileService<ProfileModel>
  ) {}
}
